import {ResourceType} from "../../definitions/types";
import {currencyFormatter} from "../../utils/helpers";

export class DesignServiceModel {
    private readonly _designService: ResourceType;

    constructor(public readonly designService: ResourceType) {
        this._designService = designService;
    }

    /**
     * @method id
     * @description Returns the id of the design service (e.g. 1, 2, 3, etc.)
     * @returns {number}
     */
    public get id(): number {
        return this._designService.id;
    }

    /**
     * @method name
     * @description Returns the name of the design service (e.g. "Design Service 1", "Design Service 2", etc.)
     * @returns {string}
     */
    public get name(): string {
        return this._designService.name;
    }

    /**
     * @method price
     * @description Returns the price of the design service
     * @returns {number}
     */
    public get price(): number {
        return this._designService.price;
    }

    /**
     * @method title
     * @description Returns the title of the design service
     * @returns {string}
     */
    public get title(): string {
        return this._designService.title;
    }

    /**
     * @method type
     * @description Returns the type of the design service
     * @returns {number}
     */
    public get type(): number {
        return this._designService.type;
    }

    /**
     * @method formatted
     * @description Returns the fields of the model formatted for display
     * @returns {{price: string}}
     */
    public get formatted(): { price: string } {
        return {
            price: currencyFormatter.format(this.price)
        }
    }
}